import { queryOptions } from '@tanstack/react-query';
import { api as registrationApi } from '@repo/api-kit/registration';
import { searchOrganization } from '#organizations/queries/search-organization';
import { adaptCompanyForFromJSON } from '#organizations/adapters/graphql-to-domain-adapter';

const { ApiCompany: ApiCompanyFromJSON } = registrationApi.company.firstparty.v1;

const all = ['company'] as const;

export const companyQueries = {
  all,
  detail: (organizationId: string) =>
    queryOptions({
      queryKey: [...all, organizationId] as const,
      queryFn: async () => {
        const graphqlOrg = await searchOrganization({
          includeFinancialDetail: false,
          organizationId,
        });
        return ApiCompanyFromJSON.fromJSON(adaptCompanyForFromJSON(graphqlOrg.company));
      },
      staleTime: Infinity,
      gcTime: Infinity,
    }),
};
